import billingStyles from "../Billing/styles";

const styles = (theme) => {
  const baseStyles = billingStyles(theme);

  return {
    ...baseStyles,
    container: {
      ...baseStyles.container,
      justifyContent: "space-between",
      columnGap: 0,
    },
    input: {
      ...baseStyles.input,
      marginRight: 0,
    },
    fieldContainer: {
      ...baseStyles.fieldContainer,
      width: 200,
      maxWidth: 200,
      alignItems: "flex-start",
    },
    namefieldContainer: {
      ...baseStyles.fieldContainer,
      width: 200,
      maxWidth: 200,
      alignItems: "flex-start",
    },
    label: {
      ...baseStyles.label,
      width: "auto",
      minWidth: "unset",
      maxWidth: "none",
      flex: "0 0 auto",
      height: 32,
      display: "flex",
      alignItems: "center",
    },
    readOnlyWrapper: {
      paddingTop: 20,
    },
  };
};

export default styles;
